module.exports = __webpack_public_path__ + "static/img/main_bg03.7f6bb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/main_bg03.png
// module id = MnDx
// module chunks = 1